




import { Vue, Component } from "vue-property-decorator"
@Component
export default class LogoutButton extends Vue {
  public logout(): void {
    this.$store.dispatch("logout")
    this.$router.push({ path: "/login" })
  }
}
